import { render, staticRenderFns } from "./CandidateExperience.vue?vue&type=template&id=627ea81b&scoped=true&"
import script from "./CandidateExperience.vue?vue&type=script&lang=js&"
export * from "./CandidateExperience.vue?vue&type=script&lang=js&"
import style0 from "./CandidateExperience.vue?vue&type=style&index=0&id=627ea81b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ea81b",
  null
  
)

export default component.exports